import React from 'react'

export type AgTechTextAreaProps = {
    header: {
        caption: string,
        body?: () => JSX.Element
    }
    text: string,
    rows: number
}

const AgTechTextArea = (props: AgTechTextAreaProps) => {
    return (
        <div className='wide row-based flex'>
            <div className='column-based wide mb-2 flex'>
                <h1 className='text-less font-semibold'>{props.header.caption}</h1>
                {props.header.body && props.header.body()}
            </div>
            <textarea
                value={props.text}
                rows={props.rows ?? 3}
                readOnly={true}
                className={'!bg-slate-100 p-2 bordered outline-none'}
                style={{
                    resize: 'none',
                }}
            />
        </div>
    )
}

export default AgTechTextArea